<template>
  <div class="suggest">
    <ul v-show="canShowSuggestedKeywords" class="suggest__items">
      <li
        v-for="(suggestedKeyword, i) in suggestedKeywords"
        :key="i"
        class="suggest__items--item"
        @click="onClickSuggestedKeyword(suggestedKeyword.keyword)"
      >
        {{ suggestedKeyword.keyword }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    canShowSuggestedKeywords: {
      type: Boolean,
      required: true
    },
    suggestedKeywords: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickSuggestedKeyword(keyword) {
      this.$emit('click-suggested-keyword', keyword)
    }
  }
}
</script>
<style lang="scss" scoped>
.suggest {
  display: none;
}

@media all and (min-width: $base-contents-width) {
  .suggest {
    display: block;
    position: absolute;
    top: 48px;
    left: 0;
    width: 100%;
    border-radius: 8px;
    &__items {
      font-size: 14px;
      background-color: white;
      text-align: left;
      max-height: 416px;
      overflow-y: scroll;
      overscroll-behavior-y: contain;
      border: 1px solid $gray-2;
      border-radius: 8px;
      &--item {
        padding: 17px 16px;
        border-bottom: 1px solid $gray-2;
        cursor: pointer;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      &--item:hover {
        background-color: $gray-3;
      }
      &--item:last-child {
        border-bottom: none;
      }
    }
  }
}
</style>
